<template>
  <section class="content-plans">
    <div class="content-plans-itens">
      <Breadcrumb :links="links" />
      <div class="content-plans-itens-body">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3">
            <router-link
              tag="a"
              :to="{ name: 'RegisterDepartment' }"
              class="content--card-register"
              style="min-height: 200px"
            >
              <img
                class="img-fluid"
                src="@/assets/img/image-plus.png"
                alt="image plus"
                title="image plus"
              />
            </router-link>
          </div>
          <template v-if="hasDepartments">
            <div
              class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3"
              v-for="department in departments"
              :key="department.id"
            >
              <CardDepartment :department="department" />
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import CardDepartment from "@/views/Company/components/CardDepartment";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Empresas",
          routerName: "Company",
        },
        {
          name: "Listar Departamentos",
          routerName: "ListDepartments",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      departments: "Company/departments",
    }),
    hasDepartments() {
      return (
        this.departments &&
        Array.isArray(this.departments) &&
        this.departments.length > 0
      );
    },
  },
  components: {
    Breadcrumb,
    CardDepartment,
  },
  methods: {
    ...mapActions("Company", ["consultDepartments"]),
  },
  mounted() {
    this.consultDepartments();
  },
};
</script>
